import { FC } from "react";
import { Image, Link } from "capitalrx-components-2.0/lib/general";
import { APPLE_STORE_APP_URL } from "@/constants/constants";

import AppStoreLogoSvg from "@/static/images/app-store.svg?url";

interface Props {
  className?: string;
}

const AppleStoreLogo: FC<Props> = ({ className }: Props): JSX.Element => {
  return (
    <Link to={APPLE_STORE_APP_URL} testId="apple-app-store-logo" className={className}>
      <Image className={className} src={AppStoreLogoSvg} alt="Apple App Store" />
    </Link>
  );
};

export default AppleStoreLogo;
